<template>
  <div class="action-float-left mx-1">
    <vx-tooltip :text="tooltip | capitalize">
        <feather-icon
        @click="handleClick"
        :icon="icon"
        svgClasses="h-5 w-5 hover:text-primary cursor-pointer action-block"
        />
    </vx-tooltip>
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    tooltip: {
      type: String,
      default: '',
    },
  },
  methods: {
    handleClick() {
        this.$emit('click')
    },
  },
}
</script>

<style>
</style>
